namespace $.$$ {
	export class $shm_hitalama_components extends $.$shm_hitalama_components {
		@ $mol_mem
		override List() { const list = super.List(); list.head_content = ()=> [ list.Head_title(), this.Help() ]; return list }
		selected( next?: string ) {
			if( next !== undefined ) {
				this.$.$mol_state_arg.dict({
					...this.$.$mol_state_arg.dict(),
					component: next,
					help: next ? 'off' : this.$.$mol_state_arg.value( 'help' ),
					application_run: null, project_module: null,
					application_tab: null, application_version: null, application_test: null,
					application_draft: null, application_draft_edit: null,
				})
				return next
			}
			return this.$.$mol_state_arg.value( 'component' ) ?? ( this.$.$mol_state_arg.value( 'project' )?.startsWith( 'hyperbase:' ) ? this.$.$mol_state_arg.value( 'project_module' ) : '' ) ?? ''
		}
		definition() {
			const definition = this.$.$shm_hitalama_components_catalog.current()?.definition( this.selected() )
			if( !definition ) throw new Error( 'Модуль не найден в каталоге домена.' )
			this.$.$shm_hitalama_map_component_ready.read( definition )
			return definition
		}
		@ $mol_mem
		application_tab( next?: string ) { return this.$.$mol_state_arg.value( 'application_tab', next ) ?? 'preview' }
		@ $mol_mem
		application_version( next?: string ) { return this.$.$mol_state_arg.value( 'application_version', next ) ?? '' }
		@ $mol_mem
		application_test( next?: string ) { return this.$.$mol_state_arg.value( 'application_test', next ) ?? '' }
		version_entry() {
			const entry = [ ...this.Versions().entries(), ...this.Versions().archived_entries() ].find( entry => entry.link().str === this.application_version() )
			if( !entry ) throw new Error( 'Версия не найдена в истории приложения.' )
			return entry
		}
		@ $mol_mem
		demo_mocked( next?: boolean ) { this.selected(); return next ?? true }
		component_pages() {
			if( !this.selected() ) return [ this.List() ]
			// Keep only the user's mode across pages, not the running preview instance.
			this.demo_mocked()
			if( this.$.$mol_state_arg.value( 'application_run' ) === 'true' ) return [ this.List(), this.Launch() ]
			const pages: $mol_view[] = [ this.List(), this.Menu() ]
			switch( this.application_tab() ) {
				case 'settings': return [ ...pages, this.Parameters() ]
				case 'code': return [ ...pages, this.Editor(), this.Preview() ]
				case 'tests': return [ ...pages, this.Tests(), ...( this.application_test() ? [ this.Test() ] : [] ) ]
				case 'drafts': return [ ...pages, this.Drafts() ]
				case 'history': return [ ...pages, this.History(), ...( this.application_version() ? [ this.Version() ] : [] ) ]
				default: return [ ...pages, this.Preview() ]
			}
		}
		catalog() { return this.$.$shm_hitalama_components_catalog.current()! }
		@ $mol_action
		application_removed( event?: Event | null ) {
			if( event ) this.selected( '' )
			return null
		}
		drag_locked() { return Boolean( this.query().trim() ) }
		drag_reversed() { return this.sort_order() === 'desc' }
		@ $mol_mem
		hierarchy() {
			const query = this.query().toLowerCase().trim()
			const catalog = this.$.$shm_hitalama_components_catalog.current()
			const definitions = catalog?.definitions() ?? []
			const folders = catalog?.folders() ?? []
			for( const item of [ ...definitions, ...folders ] ) this.$.$shm_hitalama_map_component_ready.read( item )
			const tree = catalog?.tree() ?? new this.$.$shm_hitalama_components_tree( [] )
			if( !query ) return tree
			const matches = new Set([
				... definitions.filter( item => item.display_name().toLowerCase().includes( query ) || item.class_name().toLowerCase().includes( query ) ).map( item => item.class_name() ),
				... folders.filter( item => item.title().toLowerCase().includes( query ) ).map( item => item.link().str ),
			])
			const keep = ( id: string, inherited = false ): boolean => {
				const match = inherited || matches.has( id )
				const children = tree.children( id ).filter( child => keep( child, match ) )
				tree.nodes.set( id, children )
				return match || children.length > 0
			}
			tree.roots.splice( 0, tree.roots.length, ...tree.roots.filter( id => keep( id ) ) )
			return tree
		}
		roots() { const roots = this.hierarchy().roots; return this.sort_order() === 'desc' ? [ ...roots ].reverse() : roots }
		children( id: string ) { const children = this.hierarchy().children( id ); return this.sort_order() === 'desc' ? [ ...children ].reverse() : children }
		@ $mol_mem_key
		expanded( id: string, next?: boolean ) {
			if( this.query().trim() ) return true
			return this.$.$mol_state_local.value<boolean>( `${ this }.Names().expanded(${ JSON.stringify( id ) })`, next ) ?? true
		}
		item( id: string ) { return id.startsWith( '$' ) ? this.Row( id ) : this.Group_row( id ) }
		row_arg( fqn: string ) { return { component: fqn, project_module: null, application_run: null, application_tab: null, application_version: null, application_test: null, application_draft: null, application_draft_edit: null, help: 'off' } }
		new_name_hint() { return this.create_kind() === 'group' ? 'Название группы' : 'Полное имя, например ' + '$' + 'shm2_button' }
		create_title() { return this.create_kind() === 'group' ? 'Создать группу' : 'Создать приложение' }
		add_content() { return [ this.create_kind() ? this.Create_form() : this.Add_menu() ] }
		@ $mol_action
		add_enter( event?: MouseEvent ) {
			if( !event ) return null
			if( !this.Add().showed() ) this.create_kind( '' )
			this.Add().event_show( event )
			return null
		}
		@ $mol_action
		add_open( event?: Event ) {
			if( !event ) return null
			this.create_kind( '' )
			this.Add().hovered( true )
			return null
		}
		@ $mol_action
		add_keydown( event?: KeyboardEvent ) {
			if( event?.key === 'Escape' ) {
				event.preventDefault()
				this.close_add()
			}
			return null
		}
		@ $mol_action
		close_add() {
			this.Add().hovered( false )
			this.List().focused( true )
		}
		@ $mol_action
		add_application( event?: Event ) { if( event ) this.start_create( 'application' ); return null }
		@ $mol_action
		add_group( event?: Event ) { if( event ) this.start_create( 'group' ); return null }
		@ $mol_action
		start_create( kind: string, parent = '' ) {
			this.new_name( '' )
			this.new_parent( parent )
			this.create_kind( kind )
			this.Add_anchor().focused( true )
			this.Add().hovered( true )
		}
		@ $mol_action
		cancel_create( event?: Event ) { if( event ) this.create_kind( '' ); return null }
		folder_options() {
			return { '': 'Без группы', ...Object.fromEntries( ( this.$.$shm_hitalama_components_catalog.current()?.folders() ?? [] ).map( folder => [ folder.link().str, folder.title() ] ) ) }
		}
		folder_title( id: string, next?: string ) {
			const folder = this.catalog().folder( id )!
			return folder.title( next === undefined ? undefined : next.trim() || folder.title() )
		}
		@ $mol_mem_key
		folder_editing( id: string, next = false ) { return next }
		@ $mol_mem_key
		folder_draft( id: string, next?: string ) { return next ?? this.folder_title( id ) }
		group_content( id: string ) { return this.folder_editing( id ) ? [ this.Folder_name( id ) ] : [ this.Group( id ) ] }
		@ $mol_action
		folder_rename_start( id: string, event?: Event ) {
			if( !event ) return null
			event.preventDefault(); event.stopPropagation()
			if( !this.catalog().can_change() ) return null
			this.folder_draft( id, this.folder_title( id ) )
			this.folder_editing( id, true )
			new this.$.$mol_after_frame( () => {
				this.Folder_name( id ).focused( true )
				this.Folder_name( id ).selection([ 0, this.folder_draft( id ).length ])
			} )
			return null
		}
		@ $mol_action
		folder_rename_submit( id: string, event?: Event ) {
			if( event && this.folder_editing( id ) ) { this.folder_title( id, this.folder_draft( id ) ); this.folder_editing( id, false ) }
			return null
		}
		@ $mol_action
		folder_rename_keydown( id: string, event?: KeyboardEvent ) {
			if( event?.key === 'Escape' ) { event.preventDefault(); event.stopPropagation(); this.folder_editing( id, false ) }
			return null
		}
		@ $mol_action
		folder_input_pointerdown( id: string, event?: PointerEvent ) { event?.stopPropagation(); return null }
		@ $mol_action
		folder_contextmenu( id: string, event?: MouseEvent ) {
			if( event ) { event.preventDefault(); event.stopPropagation(); this.Group( id ).showed( true ) }
			return null
		}
		@ $mol_action
		folder_menu_rename( id: string, event?: Event ) { if( event ) this.Group( id ).showed( false ); return this.folder_rename_start( id, event ) }
		@ $mol_action
		folder_delete( id: string, event?: Event ) {
			if( !event ) return null
			$mol_wire_sync( this.catalog() ).folder_remove( id )
			this.Group( id ).showed( false )
			return null
		}
		application_options() { const tree = this.catalog()?.tree(); return Object.fromEntries( ( this.catalog()?.definitions() ?? [] ).filter( item => tree?.movable( item.class_name() ) ).map( item => [ item.class_name(), item.display_name() ] ) ) }
		@ $mol_action
		group_add_application( id: string, event?: Event ) {
			if( event ) { this.Group( id ).showed( false ); this.start_create( 'application', id ) }
			return null
		}
		@ $mol_action
		group_add_group( id: string, event?: Event ) {
			if( event ) { this.Group( id ).showed( false ); this.start_create( 'group', id ) }
			return null
		}
		@ $mol_action
		move_application( id: string, next?: string ) {
			if( next ) this.$.$shm_hitalama_components_catalog.current()!.application_move( next, id )
			return ''
		}
		row_title( fqn: string ) { return this.$.$shm_hitalama_components_catalog.current()?.definition( fqn )?.display_name() || fqn }
		row_fqn( fqn: string ) { return fqn }
		@ $mol_action
		create( event?: Event ) {
			if( !event ) return null
			const catalog = this.$.$shm_hitalama_components_catalog.ensure()
			if( this.create_kind() === 'group' ) {
				catalog.folder_create( event, this.new_name(), this.new_parent() )
			} else {
				const definition = catalog.create( event, this.new_name() )
				if( catalog.tree().movable( definition.class_name() ) ) catalog.application_move( definition.class_name(), this.new_parent() )
				this.selected( definition.class_name() )
			}
			this.close_add()
			this.create_kind( '' )
			return null
		}
	}
}
